<template>
  <div>
    <table id="table" class="table table-hover">
      <thead></thead>
      <tbody>
        <tr>
          <th scope="row">Probability of GPC class "{{ probabilities.predictions[0][0] }}</th>
          <td class="float-left">{{ probabilities.predictions[0][1] }}</td>
        </tr>
        <tr>
          <th scope="row">Probability of GPC class "{{ probabilities.predictions[1][0] }}</th>
          <td class="float-left">{{ probabilities.predictions[1][1] }}</td>
        </tr>
        <tr>
          <th scope="row">Probability of GPC class "{{ probabilities.predictions[2][0] }}</th>
          <td class="float-left">{{ probabilities.predictions[2][1] }}</td>
        </tr>
        <tr>
          <th scope="row">Probability of GPC class "{{ probabilities.predictions[3][0] }}</th>
          <td class="float-left">{{ probabilities.predictions[3][1] }}</td>
        </tr>
        <tr>
          <th scope="row">Probability of GPC class "{{ probabilities.predictions[4][0] }}</th>
          <td class="float-left">{{ probabilities.predictions[4][1] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ShowPreds",
  props: {
    probabilities: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  color: rgb(157, 185, 125);
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  margin: 50px 25px 0 10px;
  text-align: left;
  /*background: rgb(2, 134, 249);*/
}
</style>
